// extracted by mini-css-extract-plugin
export default {"headerLogoImage":"Header_headerLogoImage__Zz8II"};